import { render } from "./BienvenidaPage_ingles.vue?vue&type=template&id=402c0884&scoped=true"
import script from "./BienvenidaPage_ingles.vue?vue&type=script&lang=js"
export * from "./BienvenidaPage_ingles.vue?vue&type=script&lang=js"

import "./BienvenidaPage_ingles.vue?vue&type=style&index=0&id=402c0884&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-402c0884"]])

export default __exports__